import { getWPPostMedia } from 'services/wp';
import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'

const Card = ({ cardContent }) => {

    const [featureImage, setFeatureImage] = useState();
    const [isErrorImage, setIsErrorImage] = useState(false);
    const [isImageLoading, setIsImageLoading] = useState(true);

    const backgroundFallback = (
        <div className='bg-primary/25 w-full h-52'></div>
    )

    useEffect(() => {

        const fetchPostMedia = async () => {
            try {
                const media = await getWPPostMedia(cardContent);
                setFeatureImage(media.media_details.sizes.full.source_url)
                setIsImageLoading(false)
            } catch (error) {
                console.error(`Error: ${error}`)
                setFeatureImage(null)
                setIsErrorImage(true)
            } finally {
                setIsImageLoading(false)
            }
        }

        fetchPostMedia()

    }, [cardContent]);

    return (
        <div className="card w-[22.5rem] bg-base-100 shadow-xl">
            <figure className='h-52'>
                {
                    isImageLoading ? backgroundFallback :
                        isErrorImage ? backgroundFallback :
                            <img src={featureImage} alt="Featured Blog" />
                }
            </figure>
            <div className="card-body">
                <div className='tooltip tooltip-top' data-tip={cardContent.title.rendered}>
                    <div className="text-xl card-title text-left line-clamp-2" >{cardContent.title.rendered}</div>
                </div>
                <div className='line-clamp-5' dangerouslySetInnerHTML={{ __html: cardContent.excerpt.rendered ? cardContent.excerpt.rendered.replace(/\bMaryland\b\s*/gi, '') : '' }} />
                <div className="card-actions justify-end">
                    <Link to={cardContent.id.toString()} ><button className="btn btn-secondary text-base-100">Read more</button></Link>
                </div>
            </div>
        </div>
    )
}

export default Card